import { loadStripe } from "@stripe/stripe-js"

/**
 * Singleton Stripe.js instance. `loadStripe` returns a Promise the very
 * first time it's called and the same Promise on subsequent calls — so
 * exporting the Promise once means every consumer shares one Stripe
 * runtime download.
 *
 * Publishable keys are safe to commit — they're sent to the browser on every
 * page load anyway, every Stripe-using site exposes theirs. The secret key
 * is the one that must never leave the server.
 *
 * Live publishable key hard-coded below. To override (e.g. point a build back
 * at test), set REACT_APP_STRIPE_PUBLISHABLE_KEY in the build environment
 * (.env.production for CRA), which takes precedence over this fallback.
 */
const LIVE_PUBLISHABLE_KEY = "pk_live_51SE4CfPvZViY0DeIEu6wYsqnrnWzVo3Jfb4xbXptabYj1kSlzdiBwDrchjiONhM6Z97QxCR8wiMgkd9JKosLb2nx00NTzjMW36"

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || LIVE_PUBLISHABLE_KEY

export const stripePromise = loadStripe(publishableKey)
